import React from 'react'

export { Logo } from './Logo'

export const IconDuration = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1.25em'
    height='1.25em'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='feather feather-clock'
  >
    <circle cx='12' cy='12' r='10' />
    <polyline points='12 6 12 12 16 14' />
  </svg>
)

export const IconLength = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1.25em'
    height='1.25em'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='feather feather-maximize-2'
  >
    <g transform='translate(0 2) rotate(45 12 12) scale(0.9)'>
      <polyline points='15 3 21 3 21 9' />
      <polyline points='9 21 3 21 3 15' />
      <line x1='21' y1='3' x2='14' y2='10' />
      <line x1='3' y1='21' x2='10' y2='14' />
    </g>
  </svg>
)

export const IconClassification = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1.25em'
    height='1.25em'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='feather feather-alert-triangle'
  >
    <path d='M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z' />
    <line x1='12' y1='9' x2='12' y2='13' />
    <line x1='12' y1='17' x2='12' y2='17' />
  </svg>
)

export const IconMap = () => (
  <svg
    width='100'
    height='100'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 100 100'
    fill='currentColor'
  >
    <path
      transform='translate(13 17)'
      d='M0 14l-.992-1.736A2 2 0 0 0-2 14h2zm0 56h-2a2 2 0 0 0 2.992 1.737L0 70zm24.5-14l.894-1.789a2 2 0 0 0-1.886.053L24.5 56zm28 14l-.894 1.789a2 2 0 0 0 1.886-.052L52.5 70zM77 56l.992 1.736A2 2 0 0 0 79 56h-2zm0-56h2a2 2 0 0 0-2.992-1.736L77 0zM52.5 14l-.894 1.789a2 2 0 0 0 1.886-.053L52.5 14zm-28-14l.894-1.789a2 2 0 0 0-1.886.053L24.5 0zM-2 14v56h4V14h-4zM.992 71.737l24.5-14-1.984-3.474-24.5 14 1.984 3.474zm22.614-13.948l28 14 1.788-3.578-28-14-1.788 3.578zm29.886 13.948l24.5-14-1.984-3.474-24.5 14 1.984 3.474zM79 56V0h-4v56h4zM76.008-1.736l-24.5 14 1.984 3.473 24.5-14-1.984-3.473zM53.394 12.21l-28-14-1.788 3.578 28 14 1.788-3.578zM23.508-1.736l-24.5 14 1.984 3.473 24.5-14-1.984-3.473z'
    />
    <path
      transform='translate(37.5 17)'
      d='M2 0a2 2 0 1 0-4 0h4zm-4 56a2 2 0 1 0 4 0h-4zm0-56v56h4V0h-4z'
    />
    <path
      transform='translate(65.5 31)'
      d='M2 0a2 2 0 1 0-4 0h4zm-4 56a2 2 0 1 0 4 0h-4zm0-56v56h4V0h-4z'
    />
  </svg>
)
export const IconMore = () => (
  <svg
    width='18'
    height='4'
    viewBox='0 0 18 4'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    {/* Royalty Free */}
    <g id='Symbols' fill='currentColor' fillRule='evenodd'>
      <g id='Icons-/-Options' transform='translate(-1 -8) scale(0.7)'>
        <path
          d='M7,16 C5.8954305,16 5,15.1045695 5,14 C5,12.8954305 5.8954305,12 7,12 C8.1045695,12 9,12.8954305 9,14 C9,15.1045695 8.1045695,16 7,16 Z M14,16 C12.8954305,16 12,15.1045695 12,14 C12,12.8954305 12.8954305,12 14,12 C15.1045695,12 16,12.8954305 16,14 C16,15.1045695 15.1045695,16 14,16 Z M21,16 C19.8954305,16 19,15.1045695 19,14 C19,12.8954305 19.8954305,12 21,12 C22.1045695,12 23,12.8954305 23,14 C23,15.1045695 22.1045695,16 21,16 Z'
          id='path-1'
        />
      </g>
    </g>
  </svg>
)

export const IconTracks = () => (
  <svg
    width='100'
    height='100'
    viewBox='0 0 100 100'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      transform='translate(18 18.5)'
      d='M63.19 17.497H9.029c-.48 0-.939-.186-1.278-.512l-7.222-7a1.713 1.713 0 0 1 0-2.474l7.222-7C8.09.182 8.548 0 9.028 0h54.163c.729 0 1.39.427 1.668 1.081a1.713 1.713 0 0 1-.39 1.912l-5.944 5.76 5.944 5.761a1.7 1.7 0 0 1 .39 1.912c-.278.644-.939 1.07-1.668 1.07zm-53.415-3.5h49.057l-4.138-4.012a1.72 1.72 0 0 1 0-2.474L58.832 3.5H9.775L4.36 8.75l5.416 5.246z'
    />
    <path
      transform='translate(18 39.5)'
      d='M55.97 17.5H1.807c-.73 0-1.39-.427-1.668-1.081a1.706 1.706 0 0 1 .39-1.908L6.472 8.75.53 2.989a1.706 1.706 0 0 1-.39-1.907A1.807 1.807 0 0 1 1.807 0H55.97c.48 0 .938.185 1.278.511l7.221 7a1.713 1.713 0 0 1 0 2.474l-7.221 7c-.34.33-.798.515-1.278.515zM6.165 14h49.057l5.416-5.25-5.416-5.25H6.165l4.138 4.011a1.713 1.713 0 0 1 0 2.474L6.165 14z'
    />
    <path
      transform='translate(39.67 53.5)'
      d='M19.86 38.5H1.805C.81 38.5 0 37.716 0 36.75v-35C0 .784.809 0 1.805 0H19.86c.993 0 1.805.784 1.805 1.75v35c0 .966-.812 1.75-1.805 1.75zM3.61 35h14.444V3.5H3.611V35z'
    />
    <path
      transform='translate(39.67 32.5)'
      d='M19.86 10.5H1.805C.81 10.5 0 9.716 0 8.75v-7C0 .784.809 0 1.805 0H19.86c.993 0 1.805.784 1.805 1.75v7c0 .966-.812 1.75-1.805 1.75zM3.61 7h14.444V3.5H3.611V7z'
    />
    <path
      transform='translate(39.67 8)'
      d='M19.86 14H1.805C.81 14 0 13.216 0 12.25V1.75C0 .784.809 0 1.805 0H19.86c.993 0 1.805.784 1.805 1.75v10.5c0 .966-.812 1.75-1.805 1.75zM3.61 10.5h14.444v-7H3.611v7z'
    />
  </svg>
)

export const IconFauna = () => (
  <svg
    width='100'
    height='100'
    viewBox='0 0 100 100'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      transform='translate(5 11)'
      d='M46.713 77c-.567 0-2.077 0-2.568-1.27-.524-1.353.584-2.376 2.26-3.926 1.87-1.727 4.697-4.338 4.577-6.832-.063-1.283-.931-2.57-2.584-3.824-9.582-7.27-11.009-18.992-11.21-22.969-4.669-.738-8.495-4.258-9.948-5.765a13.444 13.444 0 0 1-4.401.264c-1.792 1.417-4.034 3.78-4.126 5.309-.023.388.1.68.416.977 1.714 1.61 2.333 3.067 1.837 4.328-.404 1.031-1.454 1.623-2.882 1.623-1.672 0-4.093-.851-5.733-2.754-1.344-1.557-1.894-3.497-1.595-5.611.146-1.026 1.18-3.002 3.297-6.777.212-.375.436-.776.627-1.12-3.606-3.434-5.674-8.076-6.456-10.093-5.32-.111-7.706-.964-8.16-2.875-.487-2.058 1.92-3.783 3.447-4.65 1.121-3.138 4.547-4.371 7.663-4.484C15.25 1.048 22.075.203 22.373.17L23.853 0l.126 1.49c.5 5.92-2.888 9.631-5.5 11.272.503.633 1.695 1.438 4.506 1.438 2.159 0 4.878-.48 8.084-1.43 2.924-.865 6.037-1.304 9.251-1.304 11.12 0 19.948 5.137 20.319 5.358 17.306 10.275 16.79 27.075 16.446 38.194-.094 3.032-.174 5.653.08 7.71.483 3.87 2.261 4.367 3.755 4.367 3.222 0 7.188-2.732 7.228-2.76L92 61.656l-1.683 4.397c-1.744 4.553-6.7 7.987-11.53 7.987-2.565 0-4.833-.939-6.563-2.711-2.454-2.519-3.647-6.464-3.545-11.726.29-15.023-4.695-23.114-7.372-26.358-1.525 3.333-5.108 6.652-6.126 7.553-.72 1.412-4.482 9.837 2.877 19.265 2.52 3.233 3.283 6.268 2.262 9.024-2.152 5.813-11.658 7.736-12.061 7.815l-.138.02c-.555.054-1.016.079-1.408.079zM28.22 29.142l.601.711c.044.051 4.628 5.38 9.827 5.553l1.427.049-.03 1.433c-.003.14-.14 14.177 10.092 21.94 2.37 1.799 3.626 3.819 3.73 6.003.186 3.818-3.178 6.963-5.445 9.057 2.687-.662 7.998-2.58 9.193-5.82.643-1.742.028-3.83-1.83-6.21-9.14-11.714-3.255-22.267-3-22.712l.123-.213.187-.162c2.541-2.192 6.087-6.231 6.02-8.34l-.1-3.087 2.427 1.89c.432.336 10.551 8.471 10.125 30.425-.084 4.39.855 7.722 2.72 9.634 1.481 1.522 3.263 1.84 4.5 1.84 1.738 0 3.5-.582 5.017-1.563-.944.263-1.926.432-2.884.432-2.152 0-5.872-.898-6.62-6.914-.282-2.282-.199-5.006-.102-8.16.34-11.058.807-26.2-15.026-35.6-.08-.047-8.544-4.954-18.853-4.954-2.937 0-5.776.398-8.437 1.187-3.469 1.025-6.463 1.546-8.898 1.547-7.456 0-7.748-4.758-7.757-4.96l-.043-1.01.925-.394c.202-.086 4.625-2.075 5.005-7.346-2.09.57-5.752 2.011-7.984 5.405l-.454.692-.824-.043c-.012 0-.085-.003-.207-.003-.808 0-4.866.141-5.517 2.913l-.153.655-.595.305c-.922.476-1.895 1.182-2.312 1.648.567.249 2.136.68 6.18.694l1.044.004.322.647c.021.064 2.05 6.743 6.296 9.746h.422l.425 1.076c.454.784.36 1.126-1.187 3.886-.838 1.494-2.8 5.08-2.954 5.861-.18 1.259.13 2.411.918 3.327.962 1.116 2.448 1.738 3.462 1.773-.159-.222-.418-.518-.836-.91-.946-.89-1.405-2.019-1.327-3.275.226-3.68 5.194-7.406 5.76-7.82l.485-.354.591.097c1.493.238 3.055.13 4.66-.327l.891-.253z'
    />
  </svg>
)
export const IconFlora = () => (
  <svg
    width='100'
    height='100'
    viewBox='0 0 100 100'
    xmlns='http://www.w3.org/2000/svg'
    fill='currentColor'
  >
    <path
      transform='translate(13 8)'
      fillRule='evenodd'
      d='M59.926 30.056c4.477 4.432 6.766 10.116 6.864 17.048.066 1-.267 4.033-.995 9.1-.065.532-.332.966-.797 1.3-.431.333-.91.45-1.441.35a1.871 1.871 0 0 1-1.294-.75 2 2 0 0 1-.398-1.5c.664-4.466.994-7.266.994-8.399-.099-5.8-2.022-10.582-5.769-14.348-2.089-2.2-5.057-3.95-8.904-5.25-1.889-.7-5.703-1.7-11.441-3-11.34-2.366-19.499-6.149-24.473-11.348-1.26-1.167-2.919-3.267-4.974-6.3l-.198-.3c-2.985 8.932-3.83 17.814-2.538 26.647C6.12 43.303 10.099 51.62 16.5 58.252c5.639 5.834 11.74 9.565 18.305 11.199 4.51 1.167 10.844.767 19.001-1.2a1.825 1.825 0 0 1 1.493.25c.464.267.764.667.895 1.2a2.13 2.13 0 0 1-.198 1.55 2.3 2.3 0 0 1-1.244.9c-5.405 1.3-10.097 1.95-14.076 1.95-2.587 0-4.875-.267-6.865-.801-7.362-1.866-14.077-5.966-20.145-12.3C6.636 53.737 2.29 44.704.633 33.906-.958 22.938.45 12.04 4.861 1.207c.33-.8.93-1.2 1.79-1.2.863-.066 1.476.284 1.842 1.05.396.8 1.11 2.033 2.137 3.7 1.825 2.732 3.301 4.599 4.428 5.599l.05.1c4.344 4.566 11.838 7.982 22.485 10.249 5.834 1.3 9.814 2.333 11.938 3.1 4.443 1.567 7.908 3.65 10.395 6.25zM71.666 88.1c-.332.466-.764.75-1.294.85l-.398.05a1.9 1.9 0 0 1-1.244-.45 1.973 1.973 0 0 1-.695-1.149C64.85 71.337 55.997 59.104 41.47 50.705a1.806 1.806 0 0 1-.944-1.2 1.977 1.977 0 0 1 .198-1.5 2.021 2.021 0 0 1 1.195-.95 1.945 1.945 0 0 1 1.492.2c15.553 9 25.07 22.115 28.551 39.347a2.017 2.017 0 0 1-.297 1.498z'
    />
  </svg>
)



// WEBPACK FOOTER //
// ./src/components/icons.js